// extracted by mini-css-extract-plugin
export default {"card":"y5-z"};